var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.7,6.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-5.2,5.2l1.8,1c0,0,0,0,0.1,0L26.7,6.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.9,23.8l-0.9-0.5l-2,2c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l3-3C16,23.8,16,23.8,16,23.8H14.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.7,17.4v-2.8l2.6-2.6c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4L22.7,17.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.5,21.9l-1.8-1l-4.4,4.4c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0L11.5,21.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.2,14.7v2.8L6.7,20c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4L9.2,14.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.7,8.2l3-3c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-2.4,2.4l-1.5-0.8C16,8.2,15.8,8.2,15.7,8.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.4,6.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L5.3,12c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0L13.4,6.7 z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.2,6.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L5.3,5.8c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0L7.2,6.7z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.7,20c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-6.7,6.7c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0L26.7,20 z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.7,26.2c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-0.5,0.5c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0 L26.7,26.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,13.3c-0.3-0.2-0.3-0.6,0-0.8l4.3-2.5c0.1-0.1,0.3-0.1,0.5,0l4.4,2.5c0.3,0.2,0.3,0.6,0,0.8l-4.4,2.5 c-0.1,0.1-0.3,0.1-0.5,0L11.4,13.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.9,19.7c-0.1-0.1-0.2-0.2-0.2-0.4v-5c0-0.4,0.4-0.6,0.7-0.4l4,2.3c0.1,0.1,0.2,0.2,0.2,0.4v5 c0,0.4-0.4,0.6-0.7,0.4L10.9,19.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.6,13.9c0.3-0.2,0.7,0.1,0.7,0.4v5c0,0.2-0.1,0.3-0.2,0.4L16.9,22c-0.3,0.2-0.7-0.1-0.7-0.4v-5 c0-0.2,0.1-0.3,0.2-0.4L20.6,13.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.dd8e3f6ee5d8e7c8120ad93e96dfff5a.svg";
export { ForwardRef as ReactComponent };